import React from 'react';
import { motion } from 'framer-motion';
import './style.scss';

export interface JUNOPushNotificationProps {
  message: any;
  onCloseNotification: Function;
  onClickNotification: Function;
  params: {
    id?: number;
    title: string;
    url?: string;
    icon?: string;
    image?: string;
  };
}

const JUNOPushNotification: React.FC<JUNOPushNotificationProps> = ({
  message,
  onCloseNotification,
  onClickNotification,
  params,
}) => {
  const { id, title, url, icon, image } = params;
  const handleCloseClick = e => {
    onCloseNotification(id);
  };
  const handleClick = e => {
    onClickNotification(id, url, message);
  };

  let avatarImage = image ? image : 'UserIcon_CrowdHub.jpg';

  return (
    <div className={`JUNOPushNotification`}>
      <motion.div className="notification_container" onClick={handleClick}>
        {icon ? (
          <div className={`notification_display_icon`}>
            <i className={icon}></i>
          </div>
        ) : (
          <div
            className={`notification_display_image`}
            style={{
              backgroundImage: `url(${App.INSTANCE.getImageSrc(avatarImage)})`,
            }}
          ></div>
        )}
        <div className="notification_display_text">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </div>
      </motion.div>
    </div>
  );
};

export default JUNOPushNotification;
